import React from "react";
import { Spin } from "antd";

import { useMessageImage } from "../api/conversations";

const MessageImage = (props) => {
  const { convData, token, setSelectedImage, closeModal, modalRef } = props;

  const { data: images } = useMessageImage({ data: convData, token });

  const selectImage = (image) => {
    setSelectedImage(image);
    closeModal(modalRef);
  };

  return (
    <div className="MessageImages">
      {images ? (
        <div className="ImagesContainer">
          {images?.data.data.map((image) => {
            return (
              <div className="SingleImage" key={image.name}>
                <img
                  src={image.thumbnail_url}
                  alt={image.name}
                  className={
                    image.has_been_sent
                      ? "MessageImage Disabled"
                      : "MessageImage"
                  }
                  onClick={() => selectImage(image.url)}
                />
                {image.has_been_sent && <span className="OverlayImage"></span>}
                {image.has_been_sent && (
                  <span className="AlreadyUsedText">Already Used</span>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <Spin tip="Loading images" />
      )}
    </div>
  );
};

export default MessageImage;
